import React from "react";
import "../css/ContentPage.css";
import "../css/FAQ.css";
import ChatButton from "../components/ChatButton";
import { Link} from "react-router-dom";
import { APP_NAME } from "../Utils/constant";


const FAQ = () => {
  return (
    <>

      <div className="content_page_wrapper">
        {/* Modern Banner Section */}
        <div className="faq-banner-section" style={{
          background: 'linear-gradient(135deg, #4A7C59 0%, #2D5A27 100%)',
          padding: '5rem 0',
          position: 'relative',
          overflow: 'hidden',
          minHeight: '400px',
          display: 'flex',
          alignItems: 'center',
          marginTop: '80px',
          zIndex: '1'
        }}>
          {/* Animated Background Elements */}
          <div className="faq-floating-element" style={{
            position: 'absolute',
            top: '10%',
            left: '5%',
            width: '80px',
            height: '80px',
            background: 'linear-gradient(45deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1))',
            borderRadius: '50%',
            animation: 'float 6s ease-in-out infinite',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.3)'
          }}></div>
          <div className="faq-floating-element" style={{
            position: 'absolute',
            top: '60%',
            right: '10%',
            width: '120px',
            height: '120px',
            background: 'linear-gradient(45deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.05))',
            borderRadius: '50%',
            animation: 'float 8s ease-in-out infinite reverse',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.2)'
          }}></div>
          <div className="faq-floating-element" style={{
            position: 'absolute',
            bottom: '20%',
            left: '15%',
            width: '60px',
            height: '60px',
            background: 'linear-gradient(45deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05))',
            borderRadius: '50%',
            animation: 'float 7s ease-in-out infinite',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.2)'
          }}></div>
          
          <div className="container faq-container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem', position: 'relative', zIndex: '2' }}>
            <div style={{ textAlign: 'center', color: 'white' }}>
              <div className="faq-banner-badge" style={{
                display: 'inline-block',
                background: 'rgba(255, 255, 255, 0.2)',
                padding: '0.75rem 2rem',
                borderRadius: '30px',
                fontSize: '1rem',
                fontWeight: '700',
                marginBottom: '2rem',
                backdropFilter: 'blur(15px)',
                border: '2px solid rgba(255, 255, 255, 0.3)',
                animation: 'slideInDown 1s ease-out 0.2s both',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                letterSpacing: '1px'
              }}>
                ❓ FREQUENTLY ASKED QUESTIONS
              </div>
              <h1 className="faq-banner-title" style={{
                fontSize: '4.5rem',
                fontWeight: '900',
                marginBottom: '1.5rem',
                lineHeight: '1.1',
                textShadow: '0 8px 16px rgba(0, 0, 0, 0.3)',
                animation: 'fadeInUp 1.2s ease-out 0.4s both',
                background: 'linear-gradient(135deg, #ffffff 0%, #f0f0f0 50%, #ffffff 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                position: 'relative'
              }}>
                FAQ
                <div style={{
                  position: 'absolute',
                  bottom: '-10px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '80px',
                  height: '4px',
                  background: 'linear-gradient(90deg, #ffffff, #4A7C59, #ffffff)',
                  borderRadius: '2px',
                  animation: 'slideInRight 1s ease-out 1s both'
                }}></div>
              </h1>
              <p className="faq-banner-description" style={{
                fontSize: '1.4rem',
                opacity: '0.95',
                maxWidth: '700px',
                margin: '0 auto',
                lineHeight: '1.6',
                animation: 'fadeInUp 1.2s ease-out 0.6s both',
                fontWeight: '500',
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
              }}>
                Find answers to the most commonly asked questions about our services and loan products.
              </p>
              
              {/* Breadcrumb Navigation */}
              <div className="faq-breadcrumb" style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '2rem',
                animation: 'fadeInUp 1.2s ease-out 0.8s both'
              }}>
                <Link 
                  to="/" 
                  className="faq-breadcrumb-link"
                  style={{ 
                    color: '#ffffff', 
                    fontWeight: '600', 
                    textDecoration: 'none',
                    padding: '0.5rem 1rem',
                    borderRadius: '20px',
                    background: 'rgba(255, 255, 255, 0.1)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  Home
                </Link>
                <span style={{ color: 'white', fontSize: '16px', margin: '0 15px', opacity: '0.8' }}>→</span>
                <span style={{ 
                  color: 'white', 
                  fontWeight: '600', 
                  fontSize: '16px',
                  padding: '0.5rem 1rem',
                  borderRadius: '20px',
                  background: 'rgba(255, 255, 255, 0.2)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.3)'
                }}>
                  FAQ
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="faq-content-section" style={{
          background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
          padding: '4rem 0',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute',
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            background: 'radial-gradient(circle at 70% 30%, rgba(74, 124, 89, 0.05) 0%, transparent 50%)',
            pointerEvents: 'none'
          }}></div>
          
          <div className="container faq-container" style={{ maxWidth: '1000px', margin: '0 auto', padding: '0 2rem', position: 'relative', zIndex: '1' }}>
            <div className="faq-main-container" style={{
              background: 'rgba(255, 255, 255, 0.95)',
              borderRadius: '20px',
              boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
              padding: '3rem',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              backdropFilter: 'blur(10px)',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div className="faq-card-top-border" style={{
                position: 'absolute',
                top: '0',
                left: '0',
                right: '0',
                height: '4px',
                background: 'linear-gradient(90deg, #4A7C59, #2D5A27)',
                zIndex: '1'
              }}></div>
              
              <h1 className="faq-main-title" style={{
                fontSize: '2.5rem',
                fontWeight: '700',
                color: '#1e293b',
                marginBottom: '3rem',
                textAlign: 'center'
              }}>
                Frequently Asked Questions
              </h1>
              
              <div className="faq-card-grid" style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
                gap: '2rem',
                marginBottom: '2rem'
              }}>
                <div className="faq-card" style={{
                  background: 'rgba(248, 250, 252, 0.8)',
                  padding: '2rem',
                  borderRadius: '16px',
                  border: '1px solid rgba(74, 124, 89, 0.1)',
                  transition: 'all 0.3s ease',
                  position: 'relative',
                  overflow: 'hidden'
                }} onMouseEnter={(e) => e.target.style.transform = 'translateY(-5px)'} onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
                  <div style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    right: '0',
                    height: '3px',
                    background: 'linear-gradient(90deg, #4A7C59, #2D5A27)',
                    zIndex: '1'
                  }}></div>
                  <h3 className="faq-card-title" style={{
                    fontSize: '1.3rem',
                    fontWeight: '600',
                    color: '#1e293b',
                    marginBottom: '1rem',
                    marginTop: '0.5rem'
                  }}>
                    What is {APP_NAME}?
                  </h3>
                  <p className="faq-card-content" style={{
                    fontSize: '1rem',
                    lineHeight: '1.6',
                    color: '#64748b',
                    margin: '0'
                  }}>
                    {APP_NAME} is a short-term loan company that provides quick
                    and convenient financial solutions to individuals in need of
                    immediate funds.
                  </p>
                </div>
                
                <div className="faq-card" style={{
                  background: 'rgba(248, 250, 252, 0.8)',
                  padding: '2rem',
                  borderRadius: '16px',
                  border: '1px solid rgba(74, 124, 89, 0.1)',
                  transition: 'all 0.3s ease',
                  position: 'relative',
                  overflow: 'hidden'
                }} onMouseEnter={(e) => e.target.style.transform = 'translateY(-5px)'} onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
                  <div style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    right: '0',
                    height: '3px',
                    background: 'linear-gradient(90deg, #4A7C59, #2D5A27)',
                    zIndex: '1'
                  }}></div>
                  <h3 className="faq-card-title" style={{
                    fontSize: '1.3rem',
                    fontWeight: '600',
                    color: '#1e293b',
                    marginBottom: '1rem',
                    marginTop: '0.5rem'
                  }}>
                    How much can I borrow from {APP_NAME}?
                  </h3>
                  <p className="faq-card-content" style={{
                    fontSize: '1rem',
                    lineHeight: '1.6',
                    color: '#64748b',
                    margin: '0'
                  }}>
                    Loan amounts vary depending on factors such as your income,
                    credit history, and local regulations. {APP_NAME} offers
                    flexible loan amounts tailored to individual needs, with
                    limits set to ensure responsible borrowing.
                  </p>
                </div>
              </div>
              
              <div className="faq-card-grid" style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
                gap: '2rem',
                marginBottom: '2rem'
              }}>
                <div className="faq-card" style={{
                  background: 'rgba(248, 250, 252, 0.8)',
                  padding: '2rem',
                  borderRadius: '16px',
                  border: '1px solid rgba(74, 124, 89, 0.1)',
                  transition: 'all 0.3s ease',
                  position: 'relative',
                  overflow: 'hidden'
                }} onMouseEnter={(e) => e.target.style.transform = 'translateY(-5px)'} onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
                  <div style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    right: '0',
                    height: '3px',
                    background: 'linear-gradient(90deg, #4A7C59, #2D5A27)',
                    zIndex: '1'
                  }}></div>
                  <h3 className="faq-card-title" style={{
                    fontSize: '1.3rem',
                    fontWeight: '600',
                    color: '#1e293b',
                    marginBottom: '1rem',
                    marginTop: '0.5rem'
                  }}>
                    How does {APP_NAME} work?
                  </h3>
                  <p className="faq-card-content" style={{
                    fontSize: '1rem',
                    lineHeight: '1.6',
                    color: '#64748b',
                    margin: '0'
                  }}>
                    {APP_NAME} offers short-term loans to eligible individuals
                    based on their income and employment status. Customers can
                    apply online or through our mobile app, and if approved, funds
                    are typically disbursed within a short period.
                  </p>
                </div>
                
                <div className="faq-card" style={{
                  background: 'rgba(248, 250, 252, 0.8)',
                  padding: '2rem',
                  borderRadius: '16px',
                  border: '1px solid rgba(74, 124, 89, 0.1)',
                  transition: 'all 0.3s ease',
                  position: 'relative',
                  overflow: 'hidden'
                }} onMouseEnter={(e) => e.target.style.transform = 'translateY(-5px)'} onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
                  <div style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    right: '0',
                    height: '3px',
                    background: 'linear-gradient(90deg, #4A7C59, #2D5A27)',
                    zIndex: '1'
                  }}></div>
                  <h3 className="faq-card-title" style={{
                    fontSize: '1.3rem',
                    fontWeight: '600',
                    color: '#1e293b',
                    marginBottom: '1rem',
                    marginTop: '0.5rem'
                  }}>
                    What are the repayment terms for {APP_NAME} loans?
                  </h3>
                  <p className="faq-card-content" style={{
                    fontSize: '1rem',
                    lineHeight: '1.6',
                    color: '#64748b',
                    margin: '0'
                  }}>
                    Repayment terms for {APP_NAME} loans vary depending on the
                    loan amount and type. Generally, loans are repaid in
                    installments over a set period, with options for bi-weekly or
                    monthly payments.
                  </p>
                </div>
              </div>

              <div className="faq-card-grid" style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
                gap: '2rem',
                marginBottom: '2rem'
              }}>
                <div className="faq-card" style={{
                  background: 'rgba(248, 250, 252, 0.8)',
                  padding: '2rem',
                  borderRadius: '16px',
                  border: '1px solid rgba(74, 124, 89, 0.1)',
                  transition: 'all 0.3s ease',
                  position: 'relative',
                  overflow: 'hidden'
                }} onMouseEnter={(e) => e.target.style.transform = 'translateY(-5px)'} onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
                  <div style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    right: '0',
                    height: '3px',
                    background: 'linear-gradient(90deg, #4A7C59, #2D5A27)',
                    zIndex: '1'
                  }}></div>
                  <h3 className="faq-card-title" style={{
                    fontSize: '1.3rem',
                    fontWeight: '600',
                    color: '#1e293b',
                    marginBottom: '1rem',
                    marginTop: '0.5rem'
                  }}>
                    What are the eligibility requirements to apply for a loan with {APP_NAME}?
                  </h3>
                  <p className="faq-card-content" style={{
                    fontSize: '1rem',
                    lineHeight: '1.6',
                    color: '#64748b',
                    margin: '0'
                  }}>
                    To qualify for a loan with {APP_NAME}, applicants typically
                    need to provide proof of employment, a steady income, and meet
                    certain credit criteria. Specific requirements may vary
                    depending on the loan product and regulations in your area.
                  </p>
                </div>
                
                <div className="faq-card" style={{
                  background: 'rgba(248, 250, 252, 0.8)',
                  padding: '2rem',
                  borderRadius: '16px',
                  border: '1px solid rgba(74, 124, 89, 0.1)',
                  transition: 'all 0.3s ease',
                  position: 'relative',
                  overflow: 'hidden'
                }} onMouseEnter={(e) => e.target.style.transform = 'translateY(-5px)'} onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
                  <div style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    right: '0',
                    height: '3px',
                    background: 'linear-gradient(90deg, #4A7C59, #2D5A27)',
                    zIndex: '1'
                  }}></div>
                  <h3 className="faq-card-title" style={{
                    fontSize: '1.3rem',
                    fontWeight: '600',
                    color: '#1e293b',
                    marginBottom: '1rem',
                    marginTop: '0.5rem'
                  }}>
                    Are there any fees associated with {APP_NAME} loans?
                  </h3>
                  <p className="faq-card-content" style={{
                    fontSize: '1rem',
                    lineHeight: '1.6',
                    color: '#64748b',
                    margin: '0'
                  }}>
                    Yes, {APP_NAME} charges fees for its services, including
                    origination fees and interest charges. The specific fees
                    applicable to your loan will be outlined in your loan
                    agreement.
                  </p>
                </div>
              </div>
              
              <div className="faq-card-grid" style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
                gap: '2rem',
                marginBottom: '2rem'
              }}>
                <div className="faq-card" style={{
                  background: 'rgba(248, 250, 252, 0.8)',
                  padding: '2rem',
                  borderRadius: '16px',
                  border: '1px solid rgba(74, 124, 89, 0.1)',
                  transition: 'all 0.3s ease',
                  position: 'relative',
                  overflow: 'hidden'
                }} onMouseEnter={(e) => e.target.style.transform = 'translateY(-5px)'} onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
                  <div style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    right: '0',
                    height: '3px',
                    background: 'linear-gradient(90deg, #4A7C59, #2D5A27)',
                    zIndex: '1'
                  }}></div>
                  <h3 className="faq-card-title" style={{
                    fontSize: '1.3rem',
                    fontWeight: '600',
                    color: '#1e293b',
                    marginBottom: '1rem',
                    marginTop: '0.5rem'
                  }}>
                    How quickly can I get funds from {APP_NAME}?
                  </h3>
                  <p className="faq-card-content" style={{
                    fontSize: '1rem',
                    lineHeight: '1.6',
                    color: '#64748b',
                    margin: '0'
                  }}>
                    {APP_NAME} strives to provide fast approval and disbursement
                    of funds. Once your loan application is approved, funds are
                    typically deposited into your account within one business day.
                  </p>
                </div>
                
                <div className="faq-card" style={{
                  background: 'rgba(248, 250, 252, 0.8)',
                  padding: '2rem',
                  borderRadius: '16px',
                  border: '1px solid rgba(74, 124, 89, 0.1)',
                  transition: 'all 0.3s ease',
                  position: 'relative',
                  overflow: 'hidden'
                }} onMouseEnter={(e) => e.target.style.transform = 'translateY(-5px)'} onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
                  <div style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    right: '0',
                    height: '3px',
                    background: 'linear-gradient(90deg, #4A7C59, #2D5A27)',
                    zIndex: '1'
                  }}></div>
                  <h3 className="faq-card-title" style={{
                    fontSize: '1.3rem',
                    fontWeight: '600',
                    color: '#1e293b',
                    marginBottom: '1rem',
                    marginTop: '0.5rem'
                  }}>
                    Can I repay my {APP_NAME} loan early?
                  </h3>
                  <p className="faq-card-content" style={{
                    fontSize: '1rem',
                    lineHeight: '1.6',
                    color: '#64748b',
                    margin: '0'
                  }}>
                    Yes, borrowers can often repay their loans early without
                    incurring penalties. Early repayment options and associated
                    fees, if any, will be detailed in your loan agreement.
                  </p>
                </div>
              </div>
              
              <div className="faq-card-grid" style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
                gap: '2rem',
                marginBottom: '2rem'
              }}>
                <div className="faq-card" style={{
                  background: 'rgba(248, 250, 252, 0.8)',
                  padding: '2rem',
                  borderRadius: '16px',
                  border: '1px solid rgba(74, 124, 89, 0.1)',
                  transition: 'all 0.3s ease',
                  position: 'relative',
                  overflow: 'hidden'
                }} onMouseEnter={(e) => e.target.style.transform = 'translateY(-5px)'} onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
                  <div style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    right: '0',
                    height: '3px',
                    background: 'linear-gradient(90deg, #4A7C59, #2D5A27)',
                    zIndex: '1'
                  }}></div>
                  <h3 className="faq-card-title" style={{
                    fontSize: '1.3rem',
                    fontWeight: '600',
                    color: '#1e293b',
                    marginBottom: '1rem',
                    marginTop: '0.5rem'
                  }}>
                    What happens if I can't repay my {APP_NAME} loan on time?
                  </h3>
                  <p className="faq-card-content" style={{
                    fontSize: '1rem',
                    lineHeight: '1.6',
                    color: '#64748b',
                    margin: '0'
                  }}>
                    If you're unable to repay your loan on time, it's essential to
                    contact {APP_NAME} immediately to discuss your options.
                    Depending on the circumstances, {APP_NAME} may offer
                    repayment extensions or alternative arrangements to help you
                    manage your debt.
                  </p>
                </div>
                
                <div className="faq-card" style={{
                  background: 'rgba(248, 250, 252, 0.8)',
                  padding: '2rem',
                  borderRadius: '16px',
                  border: '1px solid rgba(74, 124, 89, 0.1)',
                  transition: 'all 0.3s ease',
                  position: 'relative',
                  overflow: 'hidden'
                }} onMouseEnter={(e) => e.target.style.transform = 'translateY(-5px)'} onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
                  <div style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    right: '0',
                    height: '3px',
                    background: 'linear-gradient(90deg, #4A7C59, #2D5A27)',
                    zIndex: '1'
                  }}></div>
                  <h3 className="faq-card-title" style={{
                    fontSize: '1.3rem',
                    fontWeight: '600',
                    color: '#1e293b',
                    marginBottom: '1rem',
                    marginTop: '0.5rem'
                  }}>
                    Is my personal information safe with {APP_NAME}?
                  </h3>
                  <p className="faq-card-content" style={{
                    fontSize: '1rem',
                    lineHeight: '1.6',
                    color: '#64748b',
                    margin: '0'
                  }}>
                    Yes, {APP_NAME} takes the privacy and security of customer
                    information seriously. We utilize industry-standard encryption
                    and security protocols to safeguard your personal and
                    financial data.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ChatButton />
    </>
  );
};

export default FAQ;
